import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { map, startWith } from 'rxjs/operators';

import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
  MatAutocompleteSelectedEvent,
  MatAutocomplete,
} from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
interface incubDis {
  district: string;
}
@Component({
  selector: 'app-csrsdocadd-page',
  templateUrl: './csrsdocadd-page.component.html',
  styleUrls: ['./csrsdocadd-page.component.css'],
})
export class CsrsdocaddPageComponent implements OnInit {
  toppingsControl = new FormControl([]);
  districtlistdata = new FormControl();
  csruploadForm: FormGroup;
  private baseUrl = environment.url;
  private saveApi = `${this.baseUrl}csrproject/save`;
  private sectorListApi = environment.url + environment.sectorList;
  public incubatorDistrictListValue = new ReplaySubject(1);
  protected incubatorDistrictList: incubDis[] = [];
  taluks: any;
  proFile: any;
  RegFileNameValue: any;

  toppingList: string[] = [
    'Extra cheese',
    'Mushroom',
    'Onion',
    'Pepperoni',
    'Sausage',
    'Tomato',
  ];
  districtdataList: string[] = [
    'Ariyalur',
    'Chengalpattu',
    'Chennai',
    'Coimbatore',
    'Cuddalore',
    'Dharmapuri',
    'Dindigul',
    'Erode',
    'Kallakurichi',
    'Kanchipuram',
    'Kanniyakumari',
    'Karur',
    'Krishnagiri',
    'Madurai',
    'Mayiladuthurai',
    'Nagapattinam',
    'Namakkal',
    'Nilgiris',
    'Perambalur',
    'Pudukkottai',
    'Ramanathapuram',
    'Ranipet',
    'Salem',
    'Sivagangai',
    'Tenkasi',
    'Thanjavur',
    'Theni',
    'Thoothukudi',
    'Tiruchirappalli',
    'Tirunelveli',
    'Tirupathur',
    'Tiruppur',
    'Tiruvallur',
    'Tiruvannamalai',
    'Tiruvarur',
    'Vellore',
    'Viluppuram',
    'Virudhunagar',
    'Other',
  ];
  districtValues = [];
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  sectorChipdataCtrl = new FormControl();
  filteredsectors: Observable<string[]>;
  sectors: string[] = [];
  allSectors: string[] = [];
  @ViewChild('sectorInput', { static: false })
  sectorInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;

  /**
   * Component constructor.
   * @param httpClient The HTTP client to make requests to the API.
   * @param router The router to navigate between pages.
   * @param fb The form builder to create the form.
   * @param makeapi The API service to make requests to the API.
   * @param getdata The value service to get the list of values.
   * @param notify The notify service to show notifications.
   */
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService
  ) {
    /**
     * The form to submit the CSR upload.
     * The form has the following fields:
     * - id: The ID of the CSR upload.
     * - organizationName: The name of the organization.
     * - inCropYear: The year of crop production.
     * - dropRegNo: The registration number of the organization.
     * - regAddr: The registration address of the organization.
     * - mobile: The contact mobile number of the organization.
     * - spocName: The name of the SPOC.
     * - spocEmail: The email of the SPOC.
     * - spocMobile: The contact mobile number of the SPOC.
     * - name: The name of the project.
     * - email: The email of the project.
     * - projectName: The name of the project.
     * - projectSector: The sector of the project.
     * - districts: The list of districts.
     * - taluks: The taluks of the project.
     * - completionYear: The year of completion of the project.
     * - budget: The budget of the project.
     * - projectOutCome: The outcome of the project.
     * - incorpCertifDocuments: The incorporation certificate documents.
     * - twlaa80gDocuments: The 12A and 80G documents.
     * - actionPlanDocuments: The action plan documents.
     * - trackRecordDocuments: The track record documents.
     * - otherDocuments: The other documents.
     */
    this.csruploadForm = this.fb.group({
      id: ['0'],
      organizationName: ['', [Validators.required]],
      inCropYear: ['', [Validators.required]],
      dropRegNo: [''],
      regAddr: ['', [Validators.required]],
      mobile: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],
      spocName: ['', [Validators.required]],
      spocEmail: ['', [Validators.required, Validators.email]],
      spocMobile: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      projectName: ['', [Validators.required]],
      projectSector: [, [Validators.required]],
      districts: [''],
      taluks: ['', [Validators.required]],
      completionYear: [
        '',
        [Validators.required, Validators.pattern('^((\\+91-?)|0)?[0-9]{4,4}$')],
      ],
      budget: [
        '',
        [Validators.required, Validators.pattern('^((\\+91-?)|0)?[0-9]{6,7}$')],
      ],
      projectOutCome: ['', [Validators.required]],
      incorpCertifDocuments: ['', [Validators.required]],
      twlaa80gDocuments: ['', [Validators.required]],
      actionPlanDocuments: ['', [Validators.required]],
      trackRecordDocuments: [''],
      otherDocuments: [''],
    });
    /**
     * The filtered list of sectors.
     * The filtered list is obtained by filtering the list of sectors based on the value of the sector chip field.
     */
    this.filteredsectors = this.sectorChipdataCtrl.valueChanges.pipe(
      startWith(),
      map((sector: string | null) =>
        sector ? this._filter(sector) : this.allSectors.slice()
      )
    );
  }
  /**
   * Initializes the component by populating the list of sectors and years.
   * Also gets the list of years for the year of establishment and the list of years for the year of completion.
   * @returns {void}
   */
  ngOnInit(): void {
    // Populate the list of sectors
    this.sectorList();

    // Populate the list of years for the year of establishment
    this.yearIncorpratedList();

    // Populate the list of years for the year of completion
    this.yearGetList();
  }
  /**
   * Removes the first occurrence of a specific district from the list of districts.
   * Also updates the form control value if the list is empty.
   * @param {string} districtlist - The district to remove from the list.
   * @returns {void}
   */
  removedistrictlist(districtlist: string): void {
    // Find the index of the district to remove
    const district = this.districtlistdata.value as string[];

    // If the district is found, remove it from the array
    this.removeFirst(district, districtlist);

    // Update the form control value if the list is empty
    this.districtlistdata.setValue(district);
  }

  /**
   * Removes the first occurrence of a specific element from an array.
   * @template T - The type of elements in the array.
   * @param {T[]} array - The array from which the element should be removed.
   * @param {T} toRemove - The element to remove from the array.
   * @returns {void}
   */
  removeFirst<T>(array: T[], toRemove: T): void {
    // Find the index of the element to remove
    const index = array.indexOf(toRemove);

    // If the element is found, remove it from the array
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
  /**
   * Handles the removal of a specified topping from the toppings control.
   * @param {string} topping - The topping to be removed.
   */
  onToppingRemoved(topping: string): void {
    // Retrieve the current list of toppings
    const toppings = this.toppingsControl.value as string[];

    // Remove the specified topping from the list
    this.removeFirst(toppings, topping);

    // Update the toppings control value with the modified list
    this.toppingsControl.setValue(toppings);
  }
  /**
   * Handles the event when the user types a new sector in the input field and
   * presses Enter or clicks on the Add button.
   * @param {MatChipInputEvent} event - The event containing the input field and
   * its value.
   * @returns {void}
   */
  addsector(event: MatChipInputEvent): void {
    // Check if the autocomplete is open
    if (!this.matAutocomplete.isOpen) {
      // Get the input field and its value
      const input = event.input;
      const value = event.value;

      // Check if the input field has a value
      if ((value || '').trim()) {
        // Add the value to the list of sectors
        this.sectors.push(value.trim());
      }

      // Clear the input field
      if (input) {
        input.value = '';
      }

      // Reset the sector chip data control value
      this.sectorChipdataCtrl.setValue(null);
    }
  }
  /**
   * Removes the specified sector from the list of selected sectors.
   * @param sector - The sector to remove from the list.
   * @returns {void}
   */
  removesector(sector: string): void {
    // Find the index of the sector in the list of sectors
    const index = this.sectors.indexOf(sector);

    // If the sector is found, remove it from the list
    if (index >= 0) {
      this.sectors.splice(index, 1);
    }
  }
  projectSector;
  /**
   * Handles the event when a sector is selected from the autocomplete options.
   * Adds the selected sector to the list of sectors and resets the input field.
   * @param {MatAutocompleteSelectedEvent} event - The event containing the selected option.
   */
  selectedsector(event: MatAutocompleteSelectedEvent): void {
    // Add the selected sector to the sectors array
    this.sectors.push(event.option.viewValue);

    // Clear the input field for sector
    this.sectorInput.nativeElement.value = '';

    // Reset the sector chip data control value
    this.sectorChipdataCtrl.setValue(this.projectSector);
  }
  /**
   * Filter the list of sectors based on the provided value.
   * The filter is case-insensitive and returns all sectors that contain the value.
   * @param {string} value - The value to filter the sectors by.
   * @returns {string[]} An array of sectors filtered by the value.
   */
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    // Filter the list of sectors based on the provided value
    return this.allSectors.filter(
      (sector) => sector.toLowerCase().indexOf(filterValue) === 0
    );
  }
  /**
   * Calls the API to get the list of sectors and updates the local list.
   * @returns {void}
   */
  sectorList(): void {
    // Call the API to get the list of sectors
    this.makeapi.method(this.sectorListApi, '', 'get').subscribe((data) => {
      // If the response from the API contains a list of sectors, update the local list
      if (data.sectors) {
        this.allSectors = data.sectors;
      }
    });
  }
  get add() {
    return this.csruploadForm.controls;
  }
  yearData = [];
  /**
   * Populates the `yearData` array with years from the current year to 2000.
   */
  yearGetList() {
    // Define the starting year
    let val = 2000;

    // Get the current year
    const d = new Date();
    let year = d.getFullYear();

    // Loop through each year from the current year down to the starting year
    for (let i = year; i >= val; i--) {
      // Add the year to the list if it is greater than or equal to the starting year
      if (val <= i) {
        this.yearData.push(i);
      }
    }
  }
  yearincorprateData = [];
  /**
   * Populates the `yearincorprateData` array with years from the current year to 1978.
   */
  yearIncorpratedList() {
    // Define the starting year
    let val = 1978;

    // Get the current year
    const d = new Date();
    let year = d.getFullYear();

    // Loop through each year from the current year down to the starting year
    for (let i = year; i >= val; i--) {
      // Add the year to the list if it is greater than or equal to the starting year
      if (val <= i) {
        this.yearincorprateData.push(i);
      }
    }
  }

  stateValue = [];
  statevalues;
  /**
   * Loads the list of states from the assets/json/Indian.json file.
   * This is a static file that contains the list of states in India.
   * @returns {void}
   */
  stateList(): void {
    /**
     * The API endpoint to fetch the list of states
     * @type {string}
     */
    const url: string = 'assets/json/Indian.json';

    /**
     * Fetch the list of states from the API endpoint
     * @returns {Observable<any>}
     */
    this.httpClient.get<any>(url).subscribe((data: any) => {
      /**
       * The list of states
       * @type {any[]}
       */
      this.stateValue = data;

      /**
       * The list of districts in the selected state
       * @type {any[]}
       */
      this.statevalues = this.stateValue[0].states;
    });
  }
  selectedState: string = '';
  selectedCity: string = '';
  cities: any[] = [];
  /**
   * Handles the deletion of the incubator brochure document.
   * Removes the brochure file and name from the form,
   * and notifies the user of the deletion.
   */
  deleteImage() {
    if (this.proFile.incubatorYearofEstd != null) {
      // Get the brochure document
      this.makeapi.method(this.csruploadForm, '', 'get').subscribe((data) => {
        if (data.responseStatus === 'Success') {
          // Remove the brochure document from the form
          this.FileValue = '';
          this.FileName = '';
          this.disName = '';
          const getform = this.csruploadForm.value;
          getform.incubatorBrouchureFile = '';
          getform.incubatorBrouchureName = '';
          this.csruploadForm.patchValue(getform);
          // Notify the user of the deletion
          this.notify.notifysuccess(data.responseMessage);
        } else {
          // Notify the user of the deletion error
          this.notify.notifyError(data.responseMessage);
        }
      });
    } else {
      // Remove the brochure document from the form
      this.FileValue = '';
      this.FileName = '';
      this.disName = '';
      // Notify the user of the deletion
      this.notify.notifyError('Brouchure Removed Successfully');
    }
  }

  selecetdRegFile: any = [];
  urlReg: any;
  RegFileValue: any = '';
  RegFileName: any;
  documentRegValues = [];
  RegdisName;
  /**
   * Handles the file upload for the registration document.
   * Validates the file type, reads the file as a data URL,
   * and updates the form with the uploaded file data.
   * @param event The file upload event.
   */
  fileRegUpload(event) {
    this.selecetdRegFile = event.target.files[0];
    if (event.target.files && this.selecetdRegFile) {
      // Check if the file type is valid
      let reader = new FileReader();
      let imagetype = this.selecetdRegFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (
        img_crt_type === 'jpeg' ||
        img_crt_type === 'jpg' ||
        img_crt_type === 'png' ||
        img_crt_type === 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdRegFile);
        reader.onload = () => {
          this.urlReg = reader.result;
          // Split the data URL into the file name and the file data
          let spl = this.urlReg.split(',');
          this.RegFileValue = spl[1];
          this.RegFileName = this.selecetdRegFile.name;
          this.RegdisName = this.selecetdRegFile.name;
          // Update the form with the uploaded file data
          let getform = this.csruploadForm.value;
          getform.incubatorRegFileName = this.selecetdRegFile.name;
          getform.incubatorRegFile = this.RegFileValue;
          this.csruploadForm.patchValue(getform);
        };
      } else {
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formats are allowed'
        );
      }
    }
  }

  selecetdTwelFile: any = [];
  urlTwel: any;
  TwelFileValue: any = '';
  TwelFileName: any;
  TweldisName;
  /**
   * Handles the file upload for the 12AA and 80G certificate document.
   * Validates the file type, reads the file as a data URL,
   * and updates the form with the uploaded file data.
   * @param event - The file input change event.
   */
  twelldocfileUpload(event) {
    // Select the uploaded file
    this.selecetdTwelFile = event.target.files[0];
    if (event.target.files && this.selecetdTwelFile) {
      const reader = new FileReader();
      const imagetype = this.selecetdTwelFile.type;
      const imagedatatype = imagetype.split('/');
      const img_crt_type = imagedatatype[1];

      // Validate the file type
      if (
        img_crt_type === 'jpeg' ||
        img_crt_type === 'jpg' ||
        img_crt_type === 'png' ||
        img_crt_type === 'pdf'
      ) {
        // Read the file as a data URL
        reader.readAsDataURL(this.selecetdTwelFile);
        reader.onload = () => {
          this.urlTwel = reader.result;
          const spl = this.urlTwel.split(',');
          this.TwelFileValue = spl[1];
          this.TwelFileName = this.selecetdTwelFile.name;
          this.TweldisName = this.selecetdTwelFile.name;

          // Update the form with the uploaded file data
          const getform = this.csruploadForm.value;
          getform.twlaa80gDocuments = this.TwelFileValue;
        };
      } else {
        // Notify the user of invalid file type
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formats are allowed'
        );
      }
    }
  }
  selecetdActionFile: any = [];
  urlAction: any;
  ActionFileValue: any = '';
  ActionFileName: any;
  ActiondisName;
  /**
   * Handles the file upload for the action plan document.
   * Validates the file type and reads the file as a data URL,
   * and updates the form with the uploaded file.
   * @param event - The file input change event.
   */
  actiondocfileUpload(event) {
    this.selecetdActionFile = event.target.files[0];
    if (event.target.files && this.selecetdActionFile) {
      let reader = new FileReader();
      let imagetype = this.selecetdActionFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Validate the file type
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdActionFile);
        reader.onload = () => {
          this.urlAction = reader.result;
          // Split the data URL into its type and value
          let spl = this.urlAction.split(',');
          this.ActionFileValue = spl[1];
          this.ActionFileName = this.selecetdActionFile.name;
          this.ActiondisName = this.selecetdActionFile.name;
          let getform = this.csruploadForm.value;
          getform.actionPlanDocuments = this.ActionFileValue;
          this.csruploadForm.patchValue(getform);
        };
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formets are allowed'
        );
      }
    }
  }
  // new Track Record
  selecetdTrackrecFile: any = [];
  urlTrackrec: any;
  TrackrecFileValue: any = '';
  TrackrecFileName: any;
  TrackrecdisName;
  /**
   * Handles the file upload for the track record document.
   * Validates the file type and reads the file as a data URL,
   * and updates the form with the uploaded file.
   * @param event - The file input change event.
   */
  trackrecdocfileUpload(event) {
    this.selecetdTrackrecFile = event.target.files[0];
    if (event.target.files && this.selecetdTrackrecFile) {
      // Read the selected file as a data URL
      let reader = new FileReader();
      let imagetype = this.selecetdTrackrecFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdTrackrecFile);
        reader.onload = () => {
          this.urlTrackrec = reader.result;
          // Split the data URL into its type and value
          let spl = this.urlTrackrec.split(',');
          this.TrackrecFileValue = spl[1];
          this.TrackrecFileName = this.selecetdTrackrecFile.name;
          this.TrackrecdisName = this.selecetdTrackrecFile.name;
          // Update the form with the uploaded file
          let getform = this.csruploadForm.value;
          getform.trackRecordDocuments = this.TrackrecFileValue;
          this.csruploadForm.patchValue(getform);
        };
      } else {
        // Notify the user of an invalid file type
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formets are allowed'
        );
      }
    }
  }

  //  Other Records document
  selecetdOtherrecFile: any = [];
  urlOtherrec: any;
  OtherrecFileValue: any = '';
  OtherrecFileName: any;
  OtherrecdisName;
  /**
   * Handles the file upload for the other records document.
   * Validates the file type, reads the file as a data URL,
   * and updates the form with the file's data and name.
   *
   * @param event - The file input change event.
   */
  otherrecdocfileUpload(event) {
    // Get the first selected file
    this.selecetdOtherrecFile = event.target.files[0];

    // Check if any files were selected and if the selected file is valid
    if (event.target.files && this.selecetdOtherrecFile) {
      // Create a new FileReader object
      let reader = new FileReader();

      // Get the MIME type of the selected file
      let imagetype = this.selecetdOtherrecFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Validate the file type
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        // Read the file as a data URL
        reader.readAsDataURL(this.selecetdOtherrecFile);

        // On successful file read
        reader.onload = () => {
          // Store the result URL
          this.urlOtherrec = reader.result;

          // Split the URL to extract file data
          let spl = this.urlOtherrec.split(',');

          // Update form values with file data
          this.OtherrecFileValue = spl[1];
          this.OtherrecFileName = this.selecetdOtherrecFile.name;
          this.OtherrecdisName = this.selecetdOtherrecFile.name;

          // Get current form values
          let getform = this.csruploadForm.value;

          // Update the form with the uploaded file's data
          getform.otherDocuments = this.OtherrecFileValue;
        };
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formats are allowed'
        );
      }
    }
  }
  selecetdFile: any = [];
  url: any;
  FileValue: any = '';
  FileName: any;
  documentValues = [];
  disName;
  tweelName;
  /**
   * Handles the file upload for the incorporation certificate.
   * Validates the file type and reads the file as a data URL,
   * then updates the form with the uploaded file.
   * @param event The file upload event.
   */
  fileUpload(event) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      // Create a new file reader
      const reader = new FileReader();

      // Get the file type
      const imagetype = this.selecetdFile.type;
      const imagedatatype = imagetype.split('/');
      const img_crt_type = imagedatatype[1];

      // Validate the file type
      if (
        img_crt_type === 'jpeg' ||
        img_crt_type === 'jpg' ||
        img_crt_type === 'png' ||
        img_crt_type === 'pdf'
      ) {
        // Read the file as a data URL
        reader.readAsDataURL(this.selecetdFile);

        // Handle the file read event
        reader.onload = () => {
          // Get the uploaded file's data URL
          this.url = reader.result;

          // Split the data URL into its parts
          const spl = this.url.split(',');

          // Store the uploaded file's data
          this.FileValue = spl[1];

          // Store the uploaded file's name
          this.FileName = this.selecetdFile.name;

          // Store the uploaded file's display name
          this.disName = this.selecetdFile.name;
        };
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError(
          'Only *jpeg, *jpg, *png, *pdf formats are allowed'
        );
      }
    }
  }
  /**
   * Handles the change event for the "Interested Districts" multi-select dropdown.
   * Updates the form with the selected districts.
   * @param event The event object emitted by the multi-select dropdown
   */
  change(event) {
    // Extract selected districts from the event
    let selectedDistricts = event.value;

    // Update the form's districts value with the selected districts
    this.csruploadForm.value.districts = selectedDistricts;
  }
  /**
   * Event handler for the "Project Sector" multi-select dropdown.
   * Stores the selected project sectors in the form.
   * @param event The event object emitted by the multi-select dropdown
   */
  change1(event) {
    // Store the selected project sectors in the form
    const selectedSectors = event.value;
    this.csruploadForm.value.projectSector = selectedSectors;
  }
  /**
   * Deletes the incorporation certificate image and resets the form value.
   */
  deleteIncorporationImage() {
    // Reset the display name for the incorporation certificate
    this.RegdisName = '';

    // Get the current form values
    let getform = this.csruploadForm.value;

    // Clear the incorporation certificate document data
    getform.incorpCertifDocuments = '';
    this.csruploadForm.controls['incorpCertifDocuments'].setValue('');
    this.csruploadForm.controls[
      'incorpCertifDocuments'
    ].updateValueAndValidity();

    // Update the form with the cleared values
    this.csruploadForm.patchValue(getform);
  }
  /**
   * Resets the Twlaa80g document selection and clears the form values.
   */
  deleteTwlaa80gImage() {
    // Reset the displayed name for the Twlaa80g document
    this.TweldisName = '';

    // Get the current form values
    let getform = this.csruploadForm.value;

    // Clear the Twlaa80g document form values
    getform.twlaa80gDocuments = '';
    this.csruploadForm.controls['twlaa80gDocuments'].setValue('');
    this.csruploadForm.controls['twlaa80gDocuments'].updateValueAndValidity();

    // Update the form with the cleared values
    this.csruploadForm.patchValue(getform);
  }

  /**
   * Deletes the action plan document image and resets the form value.
   */
  deleteActionPlanImage() {
    // Reset the display name for the action plan document
    this.ActiondisName = '';

    // Get the current form value
    let getform = this.csruploadForm.value;

    // Clear the action plan document data
    getform.actionPlanDocuments = '';
    this.csruploadForm.controls['actionPlanDocuments'].setValue('');

    // Update the form control's validity and patch the form with the modified values
    this.csruploadForm.controls['actionPlanDocuments'].updateValueAndValidity();
    this.csruploadForm.patchValue(getform);
  }
  /**
   * Deletes the track record document image and resets the form value.
   */
  deleteTrackRecordImage() {
    // Reset the display name for the track record document
    this.TrackrecdisName = '';

    // Get the current form value
    let getform = this.csruploadForm.value;

    // Reset the track record document value in the form
    getform.trackRecordDocuments = '';

    // Update the form with the new values
    this.csruploadForm.patchValue(getform);
  }
  /**
   * Deletes the other document image and resets the form value.
   */
  deleteOtherImage() {
    // Reset the display name for the other document
    this.OtherrecdisName = '';

    // Get the current form value
    let getform = this.csruploadForm.value;

    // Clear the other document data
    getform.otherDocuments = '';

    // Update the form with the modified values
    this.csruploadForm.patchValue(getform);
  }
  /**
   * Form data object to store the form data.
   */
  formData: any = {};

  /**
   * Method to save the project data.
   */
  saveProject() {
    const url = `${this.baseUrl}/csrproject/save`;

    // Get the form data
    let getform = this.csruploadForm.value;

    // Check if the form is invalid
    if (this.csruploadForm.invalid) {
      this.csruploadForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // Set the document data
      getform.incorpCertifDocuments = {
        id: 0,
        documentName: this.RegdisName,
        documentFile: this.RegFileValue,
      };
      getform.twlaa80gDocuments = {
        id: 0,
        documentName: this.TweldisName,
        documentFile: this.TwelFileValue,
      };
      getform.actionPlanDocuments = {
        id: 0,
        documentName: this.ActiondisName,
        documentFile: this.ActionFileValue,
      };
      getform.trackRecordDocuments = {
        id: 0,
        documentName: this.TrackrecdisName,
        documentFile: this.TrackrecFileValue,
      };
      getform.otherDocuments = {
        id: 0,
        documentName: this.OtherrecdisName,
        documentFile: this.OtherrecFileValue,
      };

      // Show the loader
      this.getdata.amizhthLoader('show');

      // Make the API call
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        // Hide the loader
        this.getdata.amizhthLoader('hide');

        // Check if the response is success
        if (data.responseStatus == 'success') {
          // Show the success message
          this.notify.notifysuccess(data.responseMessage);
          // Close the current window and navigate to the upload CSR project page
          this.cancelProject();
        } else {
          // Show the error message
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  /**
   * Closes the current window and navigates to the upload CSR project page.
   */
  cancelProject() {
    // Close the current window
    window.close();
    // Navigate to the upload CSR project page
    this.router.navigateByUrl('/uploadcsrsdoc');
  }
}
